module.exports = __webpack_public_path__ + "img/Löschzug_Werksfeuerwehr.170cd5a8.svg";